module.exports = __webpack_public_path__ + "media/images/version_merge/banks/jcb_logo-828cc4dcceb4bd81b9fe846e405d2704.png";